import React from 'react';
import PropTypes from 'prop-types';
import { CustomsStatus } from './sections/status';
import { CustomsWidgetHeader } from './sections/header';
import { CustomsDeclarationsSection } from './sections/declarations';
import { CustomsWidgetFooter } from './sections/footer';

export const CustomsWidget = ({ fulfillmentPlanId, children }) => (
  <>
    <CustomsStatus fulfillmentPlanId={fulfillmentPlanId} />
    <CustomsWidgetHeader />
    {children}
    <CustomsDeclarationsSection readOnly={false} />
    <CustomsWidgetFooter />
  </>
);

CustomsWidget.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  children: PropTypes.node,
};
